export default "__VITE_ASSET__Cx8733Af__"